export const handleZipVerification = (handleLogin) => {
  handleLogin();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "zipCodeVerificationPage",
  });
};
